/** 官方超级管理员固定 8 位 ID */
export const OFFICIAL_UID = '88888888';
export const UID_PATTERN = /^[A-Z0-9]{8}$/;
const UID_CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

export const normalizeUidInput = (value) => String(value || '').trim().toUpperCase();

export const isValidUserUid = (uid, isAdmin = false) => {
  const normalized = normalizeUidInput(uid);
  if (isAdmin) return normalized === OFFICIAL_UID;
  return UID_PATTERN.test(normalized) && normalized !== OFFICIAL_UID;
};

export const randomUid8 = () => {
  let result = '';
  for (let i = 0; i < 8; i += 1) {
    result += UID_CHARSET[Math.floor(Math.random() * UID_CHARSET.length)];
  }
  return result === OFFICIAL_UID ? randomUid8() : result;
};

export const resolveUidForProfile = ({ isAdmin, serverUser, cachedProfile }) => {
  if (isAdmin) return OFFICIAL_UID;
  const candidates = [serverUser?.uid, cachedProfile?.uid].map(normalizeUidInput).filter(Boolean);
  return candidates.find((uid) => isValidUserUid(uid, false)) || null;
};

export const pickBestUid = (appProfile, cloudUser, isAdmin = false) => {
  if (isAdmin) return OFFICIAL_UID;
  const cloudUid = normalizeUidInput(cloudUser?.uid);
  const appUid = normalizeUidInput(appProfile?.uid);
  if (isValidUserUid(cloudUid, false)) return cloudUid;
  if (isValidUserUid(appUid, false)) return appUid;
  return cloudUid || appUid || null;
};

export const generateUniqueUid = async (db, ensureAuth, maxAttempts = 40) => {
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    const candidate = randomUid8();
    if (!db) return candidate;
    try {
      if (typeof ensureAuth === 'function') await ensureAuth();
      const existing = await db.collection('users').where({ uid: candidate }).limit(1).get();
      if (!existing?.data?.length) return candidate;
    } catch (error) {
      console.warn('UID 唯一性检查失败，使用候选值:', error);
      return candidate;
    }
  }
  throw new Error('无法生成唯一用户ID，请稍后重试');
};

/** 每个手机号对应唯一、不可变的 8 位 ID（云端为准） */
export const ensurePermanentUid = async (db, ensureAuth, phone, isAdmin, existingUid) => {
  if (isAdmin) return OFFICIAL_UID;

  const current = normalizeUidInput(existingUid);
  if (isValidUserUid(current, false)) return current;

  if (db && phone) {
    try {
      if (typeof ensureAuth === 'function') await ensureAuth();
      const byPhone = await db.collection('users').where({ phone: String(phone) }).limit(1).get();
      const cloudUid = normalizeUidInput(byPhone?.data?.[0]?.uid);
      if (isValidUserUid(cloudUid, false)) return cloudUid;
    } catch (error) {
      console.warn('按手机号读取云端 UID 失败:', error);
    }
  }

  return generateUniqueUid(db, ensureAuth);
};

export const fetchUserFromCloudByUid = async (db, ensureAuth, uid) => {
  if (!db || !uid) return null;
  const normalized = normalizeUidInput(uid);
  if (!UID_PATTERN.test(normalized)) return null;
  try {
    if (typeof ensureAuth === 'function') await ensureAuth();
    const res = await db.collection('users').where({ uid: normalized }).limit(1).get();
    if (!res?.data?.length) return null;
    const doc = res.data[0];
    return { ...doc, id: doc._id, _cloudId: doc._id };
  } catch (error) {
    console.warn('按 UID 查询用户失败:', error);
    return null;
  }
};
